<template>
    <div class="dkCup" :class="skinName">
        <div class="dkCup__head">
            <div class="dkCup__title">
                <strong class="dkCup__name">{{cupName}}</strong>
                <span v-if="myAvgScore > 0">得分: <span class="dkCup__score">{{myAvgScore}}</span></span>
                <span v-else>得分: <span class="dkCup__score">-</span></span>
            </div>
            <div v-if="finishTime" class="dkCup__desc">
                {{finishTime}} 完成
            </div>
            <div v-else-if="finishCupNum > 0" class="dkCup__desc">
                已完成({{finishCupNum}}/{{qNum}})
            </div>
            <div v-else class="dkCup__desc">
                未参与该擂台
            </div>

            <div v-if="games && games.length > 0" class="dkCup__btn">
                <a v-if="opened" class="dkCup__btn" href="javascript:;" @click="exchange">
                    向上收拢<i class="dkfont dk-arrow-up"></i>
                </a>
                <a v-else class="dkCup__btn" href="javascript:;" @click="exchange">
                    向下展开<i class="dkfont dk-arrow-down"></i>
                </a>
            </div>
        </div>
        <div class="dkCup__body">
            <div v-if="opened && games" class="k-table k-table--games">
                <table>
                    <tr>
                        <th>序号</th>
                        <th>股票名</th>
                        <th>平均分</th>
                        <th>得分</th>
                    </tr>
                    <tr v-for="(game, index) in games" :key="game.gameId" class="dkGame">
                        <td class="dkGame__no">{{index + 1}}</td>
                        <td class="dkGame__sn">{{game.stockName}}</td>
                        <td class="dkGame__score">{{game.avgScore}}</td>
                        <td class="dkGame__score">{{game.gameScore}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="dkCup__foot">
            <!-- {{JSON.stringify(cup)}} -->
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'my-pre-cup',
        props: ['cupId', 'oid'],
        data() {
            return {
                opened: false,
                // cupPlayer: null,
                games: null
            }
        },
        computed: {
            ...mapGetters(['realityCupId', 'nowTime', 'finalRes', 'dkCup', 'dkCupPlayer']),
            ...mapGetters('reality', ['allActions']),
            skinName() {
                return `dkCup--${this.oid}`
            },
            myAvgScore() {
                const {cupPlayer, isFinished} = this
                return cupPlayer && isFinished ? cupPlayer.avgScore : '-'
            },
            cup() {
                return this.dkCup(this.cupId)
            },
            cupName(){
                return this._cup('cupName', '')
            },
            qNum(){
                return this._cup('qNum', 0)
            },
            finishCupNum() {
                return this._cupPlayer('totalGameNum', 0)
            },
            finishTime() {
                return this.isFinished ? this._cupPlayer('finishTime', '') : ''
            },
            cupPlayer() {
                return this.dkCupPlayer(this.cupId)
            },
            isFinished() {
                const {finishCupNum, qNum} = this
                return qNum > 0 && finishCupNum >= qNum
            }
        },
        methods: {
            ...mapActions(['loadDkCupPlayer', 'loadMyDkGames']),
            exchange() {
                this.opened = !this.opened
            },
            _cup(key, defaultValue){
                const {cup} = this
                return cup ? cup[key] : defaultValue
            },
            _cupPlayer(key, defaultValue){
                const {cupPlayer} = this
                return cupPlayer ? cupPlayer[key] : defaultValue
            }
        },
        async created() {
            const cupId = +this.cupId
            if (cupId > 0) {
                // const cupPlayer = await this.loadDkCupPlayer({
                //     cupId: +this.cupId
                // })
                // this.cupPlayer = cupPlayer
                // // console.log(JSON.stringify(cupPlayer));
                const games = await this.loadMyDkGames({
                    cupId
                })
                this.games = games
                // console.log(JSON.stringify(games));
            }
        }
    };

</script>
